export const warningSchema = {
  API_RESPONSE_MAPPER_INVALID_DATA_FORMAT: {
    title: 'Invalid Output Format',
    subtitle: 'APP ERROR',
    description: 'This step has returned data in an unexpected format. This indicates that the Response Mapper for this API may not be handling the data correctly and needs to be reviewed.',
    link: { text: 'Learn More', url: 'https://mindcloud.document360.io/docs/gravity-standard-response-format' }
  },
  API_RESPONSE_MAPPER_INVALID_HTTP_STATUS: {
    title: 'Invalid HTTP Status',
    subtitle: 'APP ERROR',
    description: 'The app returned an error, but the HTTP status is below 400. This suggests an issue with the Response Mapper, which should be reviewed.',
    link: { text: 'Learn More', url: 'https://mindcloud.document360.io/docs/gravity-standard-response-format' }
  },
  NO_CHILD_FOUND: {
    title: 'No Child Found',
    subtitle: 'MISSING STEP CHILD',
    description: 'This step executed successfully, but no child step was found. Please add a child step to this iterate or batch pagination step for it to function properly.'
  },
  FLOW_CONTROL_EMAIL_FAILED: {
    title: 'Flow Control Email Failed',
    subtitle: 'FLOW CONTROL EMAIL FAILED',
    description: 'The flow control email failed to send. Please check the email address and try again.'
  },
  WEBHOOK_NO_RESPONSE_OBJECT: {
    title: 'Could not send response',
    subtitle: 'Could not send response',
    description: 'This step was unable to send a response back to the webhook. This usually means the “Wait for Workflow Completion” setting is disabled in your webhook step. Without it, this step can’t send a response back.\n\nTo resolve this, go to your webhook step in the workflow. Either enable “Wait for Workflow Completion” in the Configure tab, or remove this step and set “Send Custom Response” to true.'
  },
  PARALLEL_LOOP_RAN_SEQUENTIALLY: {
    title: 'Loop ran one item at a time',
    subtitle: 'PARALLEL PROCESSING SKIPPED',
    description: 'Parallel processing is enabled on this loop, but its steps contain something that cannot run in parallel (for example a Break step, a memory write, or a step that reads the previous item’s result). The loop ran one item at a time instead. Open the loop’s Parallel Processing settings to see which steps are blocking it.'
  },
  PARALLEL_LOOP_NESTED: {
    title: 'Nested loop ran one item at a time',
    subtitle: 'PARALLEL PROCESSING SKIPPED',
    description: 'This loop is inside another loop that is already running its items in parallel, so it ran one item at a time. Only the outermost parallel loop runs items concurrently.'
  },
  WEBHOOK_HEADERS_ALREADY_SENT: {
    title: 'Response already sent',
    subtitle: "The response for this workflow's webhook has already been sent",
    description: 'The response for this workflow’s webhook has already been sent. This usually means the “Wait for Workflow Completion” setting is disabled in your webhook step. Without it, this step can’t send a response back.\n\nTo resolve this, go to your webhook step in the workflow. Either enable “Wait for Workflow Completion” in the Configure tab, or remove this step and set “Send Custom Response” to true.'
  }
};
